import { init } from './init'
import { sanitizeData, sanitizeExpire } from './Sanitize'

const actionTypes = {
  FETCH_CAMPAIGN_RESPONSE: 'FETCH_CAMPAIGN_RESPONSE',
  RESET: 'RESET',
}

const fetchReset = async (state) => {
  state = {
    ...state,
    isLoading: false,
    isStatus: true,
    expireToken: false,
    data: false,
  }
  return state
}

const fetch = async (state, campaignresponse2) => {
  state = {
    ...state,
    isStatus: campaignresponse2.status,
    expireToken: sanitizeExpire({
      status: campaignresponse2.status,
      data: campaignresponse2.data,
      name: 'campaignresponse2obj',
    }),
    data: sanitizeData({
      status: campaignresponse2.status,
      data: campaignresponse2.data,
      name: 'campaignresponse2obj',
    }),
  }
  return state
}

const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.FETCH_CAMPAIGN_RESPONSE:
      return fetch(state, action.campaignresponse2)
    case actionTypes.RESET:
      return fetchReset(state)
    default:
      return state
  }
}

const index = {
  init,
  actionTypes,
  reducer,
}

export default index
